const knownfrom = {
    namespaced: true,
    state: {
        dropdown: [
            { title: 'tenseconds.knownfrom.dropdown.family_friends', label: 'tenseconds.knownfrom.dropdown.family_friends', value: "family_friends" },
            { title: 'tenseconds.knownfrom.dropdown.festivals_cupdonation', label: 'tenseconds.knownfrom.dropdown.festivals_cupdonation', value: "festivals_cupdonation" },
            { title: 'tenseconds.knownfrom.dropdown.water', label: 'tenseconds.knownfrom.dropdown.water', value: "water" },
            { title: 'tenseconds.knownfrom.dropdown.toiletpaper', label: 'tenseconds.knownfrom.dropdown.toiletpaper', value: "toiletpaper" },
            { title: 'tenseconds.knownfrom.dropdown.arts', label: 'tenseconds.knownfrom.dropdown.arts', value: "arts" },
            { title: 'tenseconds.knownfrom.dropdown.instagram', label: 'tenseconds.knownfrom.dropdown.instagram', value: "instagram" },
            { title: 'tenseconds.knownfrom.dropdown.facebook', label: 'tenseconds.knownfrom.dropdown.facebook', value: "facebook" },
            { title: 'tenseconds.knownfrom.dropdown.shops', label: 'tenseconds.knownfrom.dropdown.shops', value: "shops" },
            { title: 'tenseconds.knownfrom.dropdown.print', label: 'tenseconds.knownfrom.dropdown.print', value: "print" },
            { title: 'tenseconds.knownfrom.dropdown.google', label: 'tenseconds.knownfrom.dropdown.google', value: "google" },
            { title: 'tenseconds.knownfrom.dropdown.none', label: 'tenseconds.knownfrom.dropdown.none', value: "none" }
        ]
    }
}
export default knownfrom
